import { useEffect, useRef, useState } from 'react';
import styled from 'styled-components';
import CarLoader from './CarLoader';
import Logo from './Logo';
import MainTitle from './MainTitle';

const Loader = styled.div`
	display: flex;
	align-items: center;
	justify-content: center;
	flex-direction: column;
	height: 100vh;

	img {
		padding-bottom: 2em;
	}

	h3 {
		padding-bottom: 2em;
	}
`;

const MSGS = [
	'Studenti se učí pravidla',
	'Auta se připravují na jízdu',
	'Zkontroluji evidenci studentů',
	'Nové jízdní hodiny jsou plánovány',
	'Dopravní značky se aktualizují',
	'Instruktoři jsou k dispozici pro konzultace',
	'Průběžná kontrola technického stavu vozidel',
	'Tréninkové jízdy jsou ve plném proudu',
	'Sleduji pokrok studentů',
	'Dopravní situace se analyzují',
	'Nové lekce se připravují',
	'Připravuji si materiály pro výuku',
	'Kontrola platnosti průkazů',
	'Dopravní pravidla jsou připomínána',
	'Jízdní plány se vyhodnocují',
	'Eviduji úspěchy studentů',
	'Sleduji bezpečnostní postupy',
	'Plány pro zkoušky se upravují',
	'Sleduji vývoj dopravních situací',
	'Studenti se učí první pomoc',
];

const AppLoader = () => {
	const refTimeout = useRef<NodeJS.Timeout | null>(null);
	const [activeMessage, setActiveMessage] = useState(MSGS[Math.floor(Math.random() * MSGS.length)]);

	const setRandomMsg = () => {
		const rndIndex = Math.floor(Math.random() * MSGS.length);
		setActiveMessage(MSGS[rndIndex]);

		refTimeout.current = setTimeout(setRandomMsg, getNextRandomMsg());
	};

	const getNextRandomMsg = () => Math.random() * 999 + 222;

	useEffect(() => {
		refTimeout.current = setTimeout(setRandomMsg, getNextRandomMsg());

		return () => {
			if (refTimeout.current) {
				clearTimeout(refTimeout.current);
			}
		};
	}, []);

	return (
		<Loader>
			<Logo />
			<MainTitle>{activeMessage}</MainTitle>
			<CarLoader size={1} />
		</Loader>
	);
};

export default AppLoader;
